export default __webpack_public_path__ + "media/images/rabbit_ui_conversation-33cbc4659c954b4ee0ac137686bc6736.png";